import { Component, OnInit, output, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'text-form',
    templateUrl: './text-form.component.html',
    styleUrls: ['./text-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TextFormComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class TextFormComponent implements OnInit, ControlValueAccessor {
  onFileSelected = output<any>();

  public message!: string;
  onChange: any = (value: any) => {};
  onTouched: any = () => {};

  constructor() { }

  writeValue(value: any): void {
    this.message = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
  }

  onTextAreaChange(event: any) {
    this.onChange(event.target.value);
  }

}
